// Gets today's date and time
const today = new Date();
const options = {
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
};
// Sets the property of the text element to be a string representing today's date in the user's local format
$w("#text811").text = today.toTimeString('en-US', {timeZone: 'America/New_York'});
